import { render, staticRenderFns } from "./OrderComponentCustom.vue?vue&type=template&id=4cf2c1c2&"
import script from "./OrderComponentCustom.vue?vue&type=script&lang=js&"
export * from "./OrderComponentCustom.vue?vue&type=script&lang=js&"
import style0 from "./OrderComponentCustom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports